//
// DataVisualization.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./DataRendererModel";
import "../data/Role";
import "./DataVisualizationTipListPolicy";
import "./styles/GraphSkinModel";
import "./CompactLabelFormatOptions";

var DataVisualization = createModule("gtl::DataVisualization", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel","gtl::DataRendererModel"], EventDispatcher, [
    {
        VISUAL_NOT_RENDERED: 30010,
    },
    {
        showMissingValuesInTips: 2,
        graphSkin: 1,
        compactLabelFormats: 2,
        auxiliary: [1],
        selectable: 2,
        _stmt: 7,
        description: 7,
        tip: [1],
        compactLabelFormatOptions: 1,
        tipListPolicy: 4,
        url: 1,
        dataTransparency: 5,
    },
    ,
    ,
    ,
    ,
    ,
]);
export default DataVisualization;
